import imageAss from "../../img/logoAssembleia.png?width=380px";
import ComponentBase from "../components/abstracts/componentBase";
import I18n from "../i18n";



export default class PageInitial extends ComponentBase{
    private static idElement = "initial"
    private static elementToRender = `
        <div id="${PageInitial.idElement}">
            <img src="${imageAss}" alt="big logo assembleia">
            <h1 class="main-title">${I18n.apply("Bem-vindo à Assembleia Nacional")}</h1>
            <button type="button">${I18n.apply("Continuar")}</button>
        </div>
    `;

    constructor(protected container:HTMLElement){
        super(container,PageInitial.idElement,PageInitial.elementToRender);
    }

    public addEventContinue(cb:(btnClicked:HTMLButtonElement)=>void){
        let btnContinue = this.elementRendered.querySelector("button") as HTMLButtonElement;
        btnContinue.addEventListener("click",function(){
            cb(btnContinue);
        });
    }
}